export default __webpack_public_path__ + "static/1.4-Focus-States-DO-1c1116834c160e75b7de844d3d3eff68.png";